import React from 'react'
import styles from './style.module.scss'

interface TimeMarkProps {
  currentTime: Date
  getCurrentTimePosition: () => number
  forWeek?: boolean
}

const TimeMark: React.FC<TimeMarkProps> = ({
  currentTime,
  getCurrentTimePosition,
  forWeek = false,
}) => {
  return (
    <>
      <div
        className={styles.currentTimeLine}
        style={{
          top: `${getCurrentTimePosition()}px`,
          left: forWeek ? '0' : '50px',
        }}
      />
      {forWeek ? (
        <div
          className={styles.currentTimeDot}
          style={{ top: `${getCurrentTimePosition() - 4}px` }}
        />
      ) : (
        <div
          className={styles.currentTimeText}
          style={{ top: `${getCurrentTimePosition() - 10}px` }}
        >
          {currentTime.getHours().toString().padStart(2, '0')}:
          {currentTime.getMinutes().toString().padStart(2, '0')}
        </div>
      )}
    </>
  )
}

export default TimeMark
